
import React from "react";
import { cn } from "@/lib/utils";

interface EscapeButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: "default" | "large";
  href?: string;
}

const EscapeButton: React.FC<EscapeButtonProps> = ({ 
  children, 
  className, 
  size = "default",
  href,
  onClick,
  ...props 
}) => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!href) {
      const plansSection = document.getElementById('planos');
      if (plansSection) {
        e.preventDefault();
        plansSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
    if (onClick) onClick(e);
  };

  if (href) {
    return (
      <a 
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={cn(
          "bg-white text-black font-bold rounded-full transition-all hover:bg-opacity-90 focus:outline-none inline-block text-center",
          size === "default" ? "px-6 py-3 text-base" : "px-8 py-4 text-lg",
          className
        )}
      >
        {children}
      </a>
    );
  }

  return (
    <button
      className={cn(
        "bg-white text-black font-bold rounded-full transition-all hover:bg-opacity-90 focus:outline-none",
        size === "default" ? "px-6 py-3 text-base" : "px-8 py-4 text-lg",
        className
      )}
      onClick={handleClick}
      {...props}
    >
      {children}
    </button>
  );
};

export default EscapeButton;
